import React from "react";
import { Box } from "@mui/material";
import { clampBarWidth } from "../../utils/utilisation";
import { toneColors, useUtilisationColors } from "./useUtilisationColors";

/**
 * A percentage bar. The fill stops at 100% of the track, but the caller's label
 * keeps the real number (120% shows a full red bar next to "120%").
 *
 * @param {number} value  - real percentage, may exceed 100
 * @param {"ok"|"over"} tone
 * @param {string} label  - accessible name, e.g. "Project budget used"
 * @param {number} height - track height in px
 */
const UtilisationBar = ({ value = 0, tone = "ok", label, height = 10 }) => {
  const colors = useUtilisationColors();
  const { main } = toneColors(colors, tone);
  const width = clampBarWidth(value);

  return (
    <Box
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(width)}
      aria-valuetext={`${Math.round(Number(value) || 0)}%`}
      sx={{ height, borderRadius: "6px", background: colors.barBg, overflow: "hidden" }}
    >
      <Box
        data-testid="utilisation-bar-fill"
        sx={{ height: "100%", width: `${width}%`, borderRadius: "6px", background: main }}
      />
    </Box>
  );
};

export default UtilisationBar;
